import { render, staticRenderFns } from "./PreviewConfiguration.vue?vue&type=template&id=23a30541&scoped=true&"
import script from "./PreviewConfiguration.vue?vue&type=script&lang=js&"
export * from "./PreviewConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PreviewConfiguration.vue?vue&type=style&index=0&id=23a30541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a30541",
  null
  
)

export default component.exports